export default {
  nav: {
    pricing: '价格',
    faq: '常见问题',
    dashboard: '控制台',
    login: '登录',
    logout: '退出',
    getAccess: '获取权限',
  },
  landing: {
    badge: 'Minecraft 实用工具',
    heroTitle: '在每个服务器占据优势。',
    heroDesc: 'Exusiai 是一款为无政府、PvP 和单人生存打造的 Minecraft 高级实用工具。功能强大的模块、简洁的界面、终身使用。',
    cta: '获取权限 — $10',
    ctaDashboard: '前往控制台',
    ctaPurchase: '购买 — $10',
    learnMore: '了解更多',
    features: {
      combat: { title: '战斗模块', desc: '精准调校的杀戮光环、暴击、攻击距离和自动点击，所有参数完全可调。' },
      movement: { title: '移动增强', desc: '冲刺、加速、飞行和无坠落模块，针对无政府服务器和绕过场景优化。' },
      esp: { title: '完整透视套件', desc: '玩家、生物和物品透视，支持自定义渲染、追踪线和血量指示。' },
      anti: { title: '反检测', desc: '专为规避主流反作弊插件而构建，定期更新以应对检测手段。' },
      hud: { title: '自定义 HUD', desc: '模块化屏幕显示，支持拖拽组件、坐标、帧率和护甲状态。' },
      license: { title: '一次性授权', desc: '一次付费，终身拥有。无订阅、无续费。HWID 绑定保障安全。' },
    },
    ctaTitle: '$10。一次付费。终身使用。',
    ctaDesc: '无订阅。无隐藏费用。付一次，Exusiai 终身归你。',
    viewPricing: '查看价格',
  },
  pricing: {
    title: '简单定价',
    subtitle: '一次购买，终身使用。',
    planName: '终身授权',
    planDesc: '包含所有当前和未来模块',
    price: '$10',
    currency: '美元',
    oneTime: '一次性付款 · 无 recurring 费用',
    features: {
      f1: '所有战斗、移动和透视模块',
      f2: '可自定义 HUD 和快捷键',
      f3: 'HWID 绑定授权（每月可重置 2 次）',
      f4: '终身免费更新',
      f5: '优先反作弊兼容性更新',
    },
    purchase: '使用 Stripe 购买',
    createAccount: '注册账号后购买',
    termsNotice: '购买即表示你同意我们的',
    terms: '条款',
    noRefunds: '不支持退款。',
  },
  auth: {
    welcomeBack: '欢迎回来',
    signInDesc: '登录你的 Exusiai 账号',
    email: '邮箱',
    password: '密码',
    forgotPassword: '忘记密码？',
    signingIn: '登录中...',
    signIn: '登录',
    dontHaveAccount: '还没有账号？',
    createOne: '注册一个',
    createAccount: '创建账号',
    joinExusiai: '$10 获取 Exusiai 使用权',
    passwordPlaceholder: '至少 8 个字符',
    creating: '创建中...',
    alreadyHaveAccount: '已有账号？',
    passwordMinLength: '密码至少需要 8 个字符',
    completeVerification: '请完成人机验证',
    invalidEmailPassword: '邮箱或密码错误',
    emailExists: '该邮箱已注册',
    resetPassword: '重置密码',
    resetDesc: '输入邮箱以接收重置链接',
    sending: '发送中...',
    sendResetLink: '发送重置链接',
    backToLogin: '返回登录',
    checkEmail: '请检查你的邮箱',
    emailSent: '如果 {{email}} 对应的账号存在，重置链接已发送。',
    newPassword: '设置新密码',
    newPasswordDesc: '为你的账号设置新密码',
    updating: '更新中...',
    updatePassword: '更新密码',
  },
  dashboard: {
    title: '控制台',
    loading: '加载中...',
    notSignedIn: '未登录',
    notSignedInDesc: '登录后访问你的控制台。',
    goToLogin: '前往登录',
    noLicense: '尚未购买',
    noLicenseDesc: '$10 购买 Exusiai，获得终身使用权。',
    purchase: '购买 — $10',
    licenseStatus: '授权状态',
    licenseId: '授权 ID',
    hwidBound: 'HWID 绑定',
    yes: '是',
    notActivated: '未激活',
    resetsThisMonth: '本月重置次数',
    purchased: '购买时间',
    download: '下载',
    downloadDesc: '下载 Exusiai 加载器。在你的电脑上运行并登录账号以激活。',
    downloadLoader: '下载加载器',
    preparing: '准备中...',
    hwidReset: 'HWID 重置',
    hwidResetDesc: '更换设备时重置硬件绑定。每月限制 {{max}} 次。',
    resetHwid: '重置 HWID',
    resetting: '重置中...',
    resetSuccess: 'HWID 重置成功，你现在可以在新设备上激活。',
    resetConfirm: '重置 HWID 绑定？这将解除当前设备的绑定，之后可在新设备上激活。',
  },
  checkout: {
    success: '支付成功',
    successDesc: '你的授权已激活，收据已发送至邮箱。',
    goToDashboard: '前往控制台',
    cancelled: '支付已取消',
    cancelledDesc: '未产生任何扣款，你可以随时重试。',
    backToPricing: '返回价格页',
  },
  faq: {
    title: '常见问题',
    items: {
      q1: 'Exusiai 是什么？',
      a1: 'Exusiai 是一款 Minecraft 高级实用工具，提供战斗、移动和视觉模块，专为无政府和 PvP 服务器以及单人世界设计。',
      q2: '多少钱？',
      a2: 'Exusiai 售价 $10 美元，一次性买断。无订阅、无续费，终身授权。',
      q3: '如何激活授权？',
      a3: '购买后，从控制台下载加载器。在加载器中登录账号，首次激活时授权会绑定到你的硬件（HWID）。',
      q4: '什么是 HWID 绑定？',
      a4: '你的授权绑定到电脑的硬件标识（硬盘、CPU 和 GPU 序列号），防止账号共享。你可以在控制台每月重置 HWID 最多 2 次。',
      q5: '升级电脑怎么办？',
      a5: '你可以从控制台重置 HWID 绑定，每月有 2 次免费重置。如需更多次数，请联系客服。',
      q6: '支持退款吗？',
      a6: '不支持。所有销售均为最终交易。建议购买前仔细查看功能和常见问题。',
      q7: '支持哪个 Minecraft 版本？',
      a7: 'Exusiai 面向 Minecraft Java 版，请查看更新日志了解最新支持的版本。',
      q8: '会被反作弊检测到吗？',
      a8: 'Exusiai 定期更新以保持与主流反作弊系统的兼容性，但没有任何工具能做到 100% 不被检测。是否在服务器上使用请自行斟酌。',
      q9: '会被封号吗？',
      a9: '会。在禁止使用此类工具的服务器上使用可能导致封号。Exusiai 专为容忍此类工具的服务器或单人模式设计。',
    },
  },
  footer: {
    tagline: '为无政府、PvP 和单人模式打造的 Minecraft 高级实用工具。',
    product: '产品',
    legal: '法律',
    terms: '条款',
    privacy: '隐私',
    rights: '保留所有权利。',
  },
  admin: {
    title: '管理面板',
    enterKey: '输入管理密钥以访问',
    unlock: '解锁',
    invalidKey: '管理密钥无效',
    currentLoader: '当前加载器',
    noLoader: '尚未上传加载器。',
    file: '文件',
    size: '大小',
    version: '版本',
    uploaded: '上传时间',
    deleteLoader: '删除加载器',
    uploadNew: '上传新加载器',
    loaderFile: '加载器文件（.exe）',
    versionLabel: '版本（可选）',
    versionPlaceholder: '例如 1.0.0',
    uploadLoader: '上传加载器',
    uploading: '上传中...',
    selectFile: '请选择文件',
    deleteConfirm: '删除当前加载器？用户将无法下载。',
    deleted: '加载器已删除',
  },
};
